"use client";
import React from "react";
import Image from "next/image";
import { Box, Center, Grid, GridItem, HStack, Stack } from "@chakra-ui/react";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import CheckImg from "public/cloudUnifiedCom/Check_circle.png";
import { COMS_CONSTANTS } from "./constants";

const FeaturesComponent = () => {
  const { heading, description, features, image } = COMS_CONSTANTS;
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();
  return (
    <Box bg="#F4F7FA" mt={{ base: 8, md: 2 }}>
      <Grid
        gap={{ base: 4, lg: 8 }}
        templateColumns={{
          base: "repeat(1, 1fr)",
          md: "repeat(5, 1fr)",
        }}
      >
        <GridItem
          colSpan={{ base: 1, md: 3 }}
          py={{ base: 8, lg: 16 }}
          pl={{
            base: "1rem",
            sm: "2rem",
            lg: "3rem",
            xl: "5rem",
            "2xl": "calc(calc(100vw - 1600px) / 2)",
            // "3xl": "calc(calc(100vw - 1800px) / 2)",
          }}
        >
          <Stack gap={10}>
            <Box>
              {heading.map((text, index) => (
                <Heading as="h3" variant={HeadingVariant} key={index}>
                  {text}
                </Heading>
              ))}
            </Box>
            <Text variant={TextVariant} color="text.100">
              {description}
            </Text>
            <Stack gap={{ base: 2, md: 6 }}>
              {features.map((point, index) => (
                <Box key={index}>
                  <HStack align="start">
                    <Image
                      alt={"Point"}
                      src={CheckImg}
                      style={{ height: "auto", width: "20px", paddingTop: "4px" }}
                    />{" "}
                    <Text variant={TextVariant} fontWeight={550}>
                      {point.label}
                    </Text>
                  </HStack>
                  <Text variant={TextVariant} color="text.100" mt={2} ml={7}>
                    {point.text}
                  </Text>
                </Box>
              ))}
            </Stack>
          </Stack>
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <Center height={"full"}>
            <Box
              h={{ base: "360px", sm: "600px", md: "full" }}
              w={{ base: "100%", sm: "100%", md: "full" }}
              position="relative"
              alignSelf={"center"}
              maxW={"640px"}
            >
              <Image
                src={image}
                alt="IntroImg"
                fill
                style={{ objectPosition: "center" }}
                placeholder="blur"
                loading="lazy"
              />
            </Box>
          </Center>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default FeaturesComponent;
